export const colors = {
  LandingPage_Background: '#121214',
  LandingPage_Description: '#FFFFFF',
  Button_Primary: '#E9AE31',
  Button_Secondary: '#FFFFFF',
  Header_Background: "#E9AE31",
  Header_Content: '#FFFFFF',
  Black: '#000000',
  Header: '#E9AE31',
  Header_Text: "#FFFFFF",
  Header_Text_back: "#b8860b",
  Table_Header: '#1e293b',
  Action_Button_Back: '#E9AE31',
  ALERT_BUTTON_GOTO_COLOR: "#E9AE31",
  ALERT_BUTTON_CLOSE_COLOR: "#ef4444",
  HEADER: '#E9AE31',
  BORDER_BACKGROUND: "#E9AE31",
  CAR_BOX_EVEN: '#eff6ff',
  CAR_BOX_ODD: '#ffffff',
  CARD_LABEL: "#FFFFFF",
  CARD_DETAIL: "#fbfbfb",
  STATUS_COMPLETE: "#22c55e",
  STATUS_CANCELED: "#ef4444",
  STATUS_PENDING: "#eab308",
  ORANGE: "#f97316",
  BLUE: "#E9AE31",
  TAXIPRIMARY: "#E9AE31",
  TAXISECONDORY: "#eff6ff",
  DELIVERYPRIMARY: "#E9AE31",
  DELIVERYSECONDORY: "#eff6ff",
  BIDTAXIPRIMARY: "#E9AE31",
  BIDTAXISECONDORY: "#eff6ff",
  WHITE: "#ffffff",
  BLACK: "#000000",
  RED: "#ef4444",
  GREEN: "#22c55e",
  YELLOW: "#eab308",
  FOOTERTOP: "#0f0f12",
  LIGHT_TEXT: "#94a3b8",
  DARK_TEXT: "#0f172a",
  INACTIVE_TAB: "#94a3b8",
}